import PaymentPlanForm from '../../../../components/Purchasing/Order/PaymentsPlan/PaymentPlanForm'
import React from 'react'
import FooterButtons from '../../../../elements/Buttons/FooterButtons'
import { Modal } from 'antd'
import { Row } from 'antd'

PaymentPlanModal.propTypes = {}

function PaymentPlanModal(props) {
  const { visible, onCancel, remove, removing, submit, update, submitting, isNew, isUpdatable, formRef } = props
  return (
    <Modal
      visible={visible}
      title={'Payment Plan'}
      onCancel={onCancel}
      destroyOnClose={true}
      footer={
        <FooterButtons
          remove={remove}
          removing={removing}
          submit={submit}
          update={update}
          submitting={submitting}
          title={'Payment Plan'}
          isNew={isNew}
          isEdit={!isNew}
        />
      }
      width={'75%'}>
      <Row>
        <PaymentPlanForm ref={formRef} {...props} />
      </Row>
    </Modal>
  )
}

export default PaymentPlanModal
